<template>
  <div class="m-b-30 card card-1 status-stat-wrapper">
     <b-row>
       <b-col cols="9"><h3>Current Active Statuses on Order & Item Stats</h3></b-col>
       <b-col cols="3">
         <b-form-select v-model="days" :options="options" @change="fetchStatusData"></b-form-select>
       </b-col>
     </b-row>
     
     <b-row class="m-b-20">
       <b-col cols="9">(Last {{days}} records)</b-col>
     </b-row>
     
     <b-row>
       <b-col md="3" sm="4" class="m-b-20"  v-for="singleStatus in statusStats" v-bind:key="singleStatus.id" >
          <single-order-item-status :status-stats="singleStatus" />
       </b-col>
       <b-col md="3" sm="4" class="m-b-20"  v-for="(singleStatus, index) in extraStatusStats" v-bind:key="index" >
          <single-order-item-status :status-stats="singleStatus" />
       </b-col>
     </b-row>
  </div>
</template>

<script>
 import DashboardService from '../../../services/dashboard.service';
 const SingleOrderItemStatus = () => import(/* webpackChunkSize: "single-order-item-status" */ "./single-order-item-status")
  export default {
    data(){
      return {
        statusStats: [],
        extraStatusStats: [],
        days: 30,
          options: [
            { value: 15, text: '15' },
            { value: 30, text: '30' },
            { value: 45, text: '45' },
            { value: 60, text: '60' },
            { value: 75, text: '75' },
            { value: 90, text: '90' },
          ],
      }
    },
    components: {SingleOrderItemStatus},
    mounted(){
      this.fetchStatusData()
    },
    computed:{
       storeInState(){
         return this.$store.state.ecommerceStore.store
       }
     },
     methods: {
       async fetchStatusData(){
          try{
            const result = await DashboardService.fetchOrderItemStatusStats(this.storeInState.id, this.days)
            this.statusStats = result.data.statusCounts
            this.extraStatusStats = result.data.extraStatusesCounts
          }catch(errors){
            console.log(errors)
          }
       }
     },
     watch: {
       storeInState(newValue, oldValue){
          this.fetchStatusData()
       }
     }
  }
</script>

<style lang="scss" scoped>
  .status-stat-wrapper{
    padding: 30px;
  }
</style>